import styled, { css } from "styled-components";
import { AiOutlineUser } from "react-icons/ai";
import { Dropdown } from "rsuite";
import { Link } from "react-router-dom";
import { Menu, Button } from "antd";

import { Input } from "antd";
import { Nav, Navbar, Image } from "react-bootstrap";

import { BiUserCircle, FaWallet } from "react-icons/all";

interface Props {
  icon2?: string;
  searchNav?: string;
  navbarHide?: boolean;
  secondaryNavbar?: boolean;
}

export const MainNavbar = styled.div<Props>`
  .navbar-light .navbar-toggler {
    border: 2px solid rgb(230, 126, 34);
  }

  .navbar-light .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(230,126,34, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
  }
`;

export const Navs = styled(Nav)<Props>`
  margin-right: auto;
  margin-left: auto;

  /* z-index: 999; */
  & > .nav-link {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #1a1a1a;
    margin-left: 20px;
  }

  @media (max-width: 991px) {
    text-align: center;

    & > .nav-link {
      margin-top: 1rem;
    }
  }

  /* .active {
    color: #d35400 !important;
  } */
  & > .nav-link.active {
    color: #d35400 !important;
  }

  & > .nav-link.noActive {
    color: black !important;
  }
`;

export const PrimaryNavbar = styled(Navbar)<Props>`
  padding: 0rem;
  min-height: 10vh;
  background: transparent !important;

  position: static;
  top: 0px;
  background-color: red;

  z-index: 999;

  /* display: ${(p) => (p.navbarHide ? "block" : " none")}; */

  & > .navbar-light .navbar-toggler {
    border: none !important;
  }

  & > .container {
    min-height: 10vh;
  }
`;
export const NavLink = styled(Link)`
  padding: 0rem;
`;

export const NavbarCollapse = styled(Navbar.Collapse)``;

export const NavLogo = styled.img`
  margin-top: -1rem;
  margin-bottom: -0.5rem;

  @media (max-width: 1920px) {
    margin-left: 2rem;
    margin-top: -1rem;
    margin-bottom: -0.5rem;
  }
  @media (max-width: 1880px) {
    margin-left: 2rem;
  }

  @media (max-width: 1440px) {
    margin-left: 0rem;
  }
  @media (max-width: 1280px) {
    margin-left: 1rem;
  }
  @media (max-width: 991px) {
    margin-top: 0rem;
  }
`;

export const SearchNavLink = styled(Input)``;

export const NavProfileIcon = styled(Image)<Props>``;

export const UserIcon = styled(AiOutlineUser)`
  width: 1.5rem;
  height: 1.5rem;
  color: #1a1a1a;

  @media (max-width: 991.98px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const WalletIcon = styled(FaWallet)`
  width: 1.5rem;
  height: 1.2rem;
  margin-top: -0.1rem;
`;

export const CurrencyDropdown = styled(Dropdown)``;
export const DropdownMain = styled.div`
  @media (max-width: 990px) {
    display: flex;
    justify-content: center;
    margin-bottom: 0.5rem;
  }
`;

export const NetworkDropdown = styled(Dropdown)`
  .rs-dropdown-toggle {
    border: 1px solid #d35400;
    border-radius: 10px;
    color: #d35400;
  }
`;

export const CurrencyMenu = styled(Menu)`
  background-color: black;
  & .ant-dropdown-menu-item {
    color: white !important;

    p {
      margin-left: 1rem;
    }
  }
`;

export const TokenItems = styled(Menu.Item)`
  .tokenMain {
    display: flex;
    flex-direction: start;
    background-color: black;
    align-items: center;
  }
  p {
    /* background: red; */
  }
`;

export const CurrencyButton = styled(Button)`
  background: #ffffff !important;
  border: 1px solid #d35400 !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #d35400 !important;
  padding: 18px 24px 18px 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 991px) {
    margin-top: 0.7rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
  }
`;

export const WalletImg = styled.img`
  margin-left: 1rem;
  cursor: pointer;
  @media (max-width: 990px) {
    display: flex;
    margin: auto;
    padding-bottom: 1rem;
  }
`;
